import { Routes } from "@angular/router";
import { MobilePublicLearningCampaignApiClient } from "./services/mobile-public-learning-campaign-api.client";
import { MobilePublicLearningCampaignService } from "./services/mobile-public-learning-campaign.service";
import { MobilePublicLearningCampaignStore } from "./services/mobile-public-learning-campaign.store";
import { MobilePublicLearningCampaignSubmissionOtpService } from "./services/mobile-public-learning-campaign-submission-otp.service";
import { MobilePublicSequenceDraftStore } from "./services/mobile-public-sequence-draft.store";

const publicLearningCampaignProviders = [
  MobilePublicLearningCampaignStore,
  MobilePublicLearningCampaignApiClient,
  MobilePublicLearningCampaignService,
  MobilePublicLearningCampaignSubmissionOtpService,
  MobilePublicSequenceDraftStore,
];

export const publicLearningCampaignRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    providers: publicLearningCampaignProviders,
    loadComponent: () =>
      import(
        "./mobile-public-learning-campaign-sequence-list-page/mobile-public-learning-campaign-sequence-list-page.component"
      ).then((moduleExports) => moduleExports.MobilePublicLearningCampaignSequenceListPageComponent),
  },
  {
    path: ":token",
    providers: publicLearningCampaignProviders,
    children: [
      {
        path: "",
        loadComponent: () =>
          import(
            "./mobile-public-learning-campaign-sequence-list-page/mobile-public-learning-campaign-sequence-list-page.component"
          ).then((moduleExports) => moduleExports.MobilePublicLearningCampaignSequenceListPageComponent),
      },
      {
        path: "sequence/:sequenceUid/activities",
        loadComponent: () =>
          import(
            "../elearning-player/mobile-elearning-activity-list-page/mobile-elearning-activity-list-page.component"
          ).then((moduleExports) => moduleExports.MobileElearningActivityListPageComponent),
      },
      {
        path: "sequence/:sequenceUid/activities/:activityUid/player",
        loadComponent: () =>
          import(
            "../elearning-player/mobile-elearning-activity-player-page/mobile-elearning-activity-player-page.component"
          ).then((moduleExports) => moduleExports.MobileElearningActivityPlayerPageComponent),
      },
      {
        path: "result",
        loadComponent: () =>
          import(
            "./mobile-public-learning-campaign-result-page/mobile-public-learning-campaign-result-page.component"
          ).then((moduleExports) => moduleExports.MobilePublicLearningCampaignResultPageComponent),
      },
    ],
  },
];
